// extracted by mini-css-extract-plugin
export default {"fontStyle":"BasicInfo_fontStyle__F9nIq"};